'use strict';

/**
 * These constants were derived from the CSV found here:
 * https://www.iana.org/assignments/jwt/jwt.xhtml#claims
 */
module.exports = {
    ISSUER: 'iss',
    SUBJECT: 'sub',
    AUDIENCE: 'aud',
    EXPIRATION_TIME: 'exp',
    NOT_BEFORE: 'nbf',
    ISSUED_AT: 'iat',
    JWT_ID: 'jti',
    NAME: 'name', //Full name
    GIVEN_NAME: 'given_name', //Given name(s) or first name(s)
    FAMILY_NAME: 'family_name', //Surname(s) or last name(s)
    MIDDLE_NAME: 'middle_name', //Middle name(s)
    NICKNAME: 'nickname', //Casual name
    PREFERRED_USERNAME: 'preferred_username', //Shorthand name by which the End-User wishes to be referred to
    PROFILE: 'profile', //Profile page URL
    PICTURE: 'picture', //Profile picture URL
    WEBSITE: 'website', //Web page or blog URL
    EMAIL: 'email', //Preferred e-mail address
    EMAIL_VERIFIED: 'email_verified', //True if the e-mail address has been verified; otherwise false
    GENDER: 'gender',
    BIRTHDATE: 'birthdate', //Birthday
    TIMEZONE: 'zoneinfo',
    LOCALE: 'locale',
    PHONE_NUMBER: 'phone_number', //Preferred telephone number
    PHONE_NUMBER_VERIFIED: 'phone_number_verified', //True if the phone number has been verified; otherwise false
    ADDRESS: 'address', //Preferred postal address
    UPDATED_AT: 'updated_at', //Time the information was last updated
    AUTHORIZED_PARTY: 'azp', //Authorized party - the party to which the ID Token was issued
    NONCE: 'nonce', //Value used to associate a Client session with an ID Token
    AUTH_TIME: 'auth_time', //Time when the authentication occurred
    ACCESS_TOKEN_HASH: 'at_hash',
    CODE_HASH: 'c_hash',
    AUTHENTICATION_CONTEXT_CLASS_REF: 'acr',
    AUTHENTICATION_METHODS_REF: 'amr',
    SUB_JWK: 'sub_jwk', //Public key used to check the signature of an ID Token
    CONFIRMATION: 'cnf',
    SIP_FROM_TAG: 'sip_from_tag', //SIP From tag header field parameter value
    SIP_DATE: 'sip_date', //SIP Date header field value
    SIP_CALLID: 'sip_callid', //SIP Call-Id header field value
    SIP_CSEQ_NUM: 'sip_cseq_num', //SIP CSeq numeric header field parameter value
    SIP_VIA_BRANCH: 'sip_via_branch', //SIP Via branch header field parameter value
    ORIGINATING_IDENTITY_STRING: 'orig',
    DESTINATION_IDENTITY_STRING: 'dest',
    MEDIA_KEY_FINGERPRINT_STRING: 'mky',
    SECURITY_EVENTS: 'events',
    TIME_OF_EVENT: 'toe',
    TRANSACTION_IDENTIFIER: 'txn',
    RESOURCE_PRIORITY_HEADER_AUTHORIZATION: 'rph',
    SESSION_ID: 'sid',
    VECTOR_OF_TRUST_VALUE: 'vot',
    VECTOR_OF_TRUST_TRUSTMARK_URL: 'vtm',
    ATTESTATION_LEVEL: 'attest', //Attestation level as defined in SHAKEN framework
    ORIGINATING_IDENTIFIER: 'origid', //Originating Identifier as defined in SHAKEN framework
    ACTOR: 'act',
    SCOPE: 'scope', //Scope Values
    CLIENT_ID: 'client_id',
    AUTHORIZED_ACTOR: 'may_act', //Authorized Actor - the party that is authorized to become the actor
    JCARD: 'jcard',
    MAX_API_REQUESTS: 'at_use_nbr', //Number of API requests for which the access token can be used
    DIVERTED_TARGET_OF_CALL: 'div',
    ORIGINAL_PASSPORT: 'opt', //Original PASSporT (in Full Form)
    VERIFIABLE_CREDENTIAL: 'vc', //Verifiable Credential as specified in the W3C Recommendation
    VERIFIABLE_PRESENTATION: 'vp', //Verifiable Presentation as specified in the W3C Recommendation
    SIP_PRIORITY_HEADER: 'sph'
};